import { ChevronLeft, ChevronRight } from '../../assets/icons/Icons';
import Styles from './pagination.module.scss';

export interface Props {
  /** What the page was selected by the user */
  onChange?: (value: number) => void;
  /** total count of records */
  count: number;
  /** Records per page */
  perPage: number;
  /** Current page number (starts at 0) */
  currentPage: number;
}

const Pagination = ({ onChange, count, perPage, currentPage }: Props) => {
  const pageCount = Math.ceil(count / perPage);

  if (pageCount <= 1) {
    // hide on empty
    return null;
  }

  // always show 7
  const isMoreThen = pageCount > 7;
  const isLastPage = currentPage === pageCount - 1;
  const isFirstPage = currentPage === 0;
  const start = Math.max(0, Math.min(currentPage, pageCount - 4) - 3);
  const end = Math.min(start + 6, pageCount - 1);

  const btns: Array<number> = [];
  for (let i = start; i <= end; i++) {
    btns.push(i);
  }

  return (
    <div className={Styles['pagination']}>
      {isMoreThen && (
        <button disabled={isFirstPage} onClick={() => onChange && onChange(0)}>
          <i className='fa-solid fa-chevrons-left'></i>
        </button>
      )}
      <button disabled={isFirstPage} onClick={() => onChange && onChange(currentPage - 1)}>
        {ChevronLeft}
      </button>
      {btns.map((m) => {
        return (
          <button key={m} className={m === currentPage ? Styles['active'] : ''} onClick={() => onChange && onChange(m)}>
            {m + 1}
          </button>
        );
      })}
      <button disabled={isLastPage} onClick={() => onChange && onChange(currentPage + 1)}>
        {ChevronRight}
      </button>
      {isMoreThen && (
        <button disabled={isLastPage} onClick={() => onChange && onChange(pageCount - 1)}>
          <i className='fa-solid fa-chevrons-right'></i>
        </button>
      )}
    </div>
  );
};

export default Pagination;
